import { render } from "./DeTaiTuChoi.vue?vue&type=template&id=f7afc54e&scoped=true&ts=true"
import script from "./DeTaiTuChoi.vue?vue&type=script&lang=ts"
export * from "./DeTaiTuChoi.vue?vue&type=script&lang=ts"

import "./DeTaiTuChoi.vue?vue&type=style&index=0&id=f7afc54e&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/NghienCuuKhoaHoc/NCKH_FontEnd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7afc54e"]])

export default __exports__